<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.dataDesejadaGruposExames"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>
export default {
    data: () => ({
        fields: [
            { key: 'nome', label: 'Nome', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(grupo) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o grupo de exame?',
                async () => this.data.model.dataDesejadaGruposExames
                    .splice(this.data.model.dataDesejadaGruposExames.indexOf(grupo), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>